module.exports = __webpack_public_path__ + "img/face-smile.eee3e36b.svg";